import { render, staticRenderFns } from "./Presentacion.vue?vue&type=template&id=e60725c2"
import script from "./Presentacion.vue?vue&type=script&lang=ts"
export * from "./Presentacion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports